<template>
    <div class="sidebar-menu">
        <div class="items">
            <div
            class="item" :class="{'selected': selectedItem === item.slug}"
            v-for="(item, index) in items"
            :key="index"
            @click="handleClick(item.slug)">
                <div class="inner">
                    <div class="count" v-if="counts[item.slug] !== null && counts[item.slug] !== '-'">
                        <span v-if="counts[item.slug] !== null || counts[item.slug] !== '-'">
                            {{ counts[item.slug] }}
                        </span>
                    </div>
                    <div class="count" v-else-if="counts[item.slug] === '-'">
                        <span>
                            -
                        </span>
                    </div>
                    <div class="count" v-else>
                        <i class="fal fa-spinner fa-spin"/>
                    </div>
                    <div class="coming-soon" v-if="item.comingsoon">
                        Kommer snart
                    </div>
                    <div class="name">
                        {{ item.name }}
                        <d-tooltip placement="inline" :identifier="item.dTooltip" v-if="item.dTooltip" />
                    </div>
                </div>
                <div class="icon" v-if="selectedItem === item.slug">
                    <svg width="600px" height="300px" viewBox="0 0 600 300" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <polygon id="Rectangle" fill="#D8D8D8" points="0 0 600 0 300 300"></polygon>
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        selectedItem: String,
        items: Array,
        counts: Object
    },
    methods: {
        handleClick (item) {
            this.$emit('selectItem', item)
        }
    }
}
</script>



// WEBPACK FOOTER //
// contentSwitch.vue?0023e127